<template>
  <va-card>
    <template slot="header">
      <h5 class="card-title">{{ $t('accounts.access_details') }}</h5>
    </template>

    <div>
      <b>{{$t('accounts.access_granted_to')}}:</b>
      <p v-if="account.permission.entity && account.permission.entity.name">{{account.permission.entity.name}}</p>
      <p v-else>---</p>
    </div>
    <div>
      <b>{{$t('accounts.access_requested_by')}}:</b>
      <p v-if="account.permission.created_by && account.permission.created_by.name">{{account.permission.created_by.name}}</p>
      <p v-else>---</p>
    </div>
    <div>
      <b>{{$t('accounts.access_requested_at')}}:</b>
      &nbsp;
      <va-popover
        :message="moment(account.permission.created_at).format('YYYY-MM-DD HH:mm:ss')"
        placement="left"
      >
        <i class="fa fa-question-circle"></i>
      </va-popover>
      <p v-if="account.permission.created_at">{{account.permission.created_at | readableDate | capitalize}}</p>
      <p v-else>---</p>
    </div>
    <div>
      <b>{{$t('accounts.access_status')}}:</b>
      <p>{{$t('accounts.statuses.approved')}}</p>
    </div>
    <div>
      <b>{{$t('accounts.access_approved_at')}}:</b>
      &nbsp;
      <va-popover
        :message="moment(account.permission.updated_at).format('YYYY-MM-DD HH:mm:ss')"
        placement="left"
      >
        <i class="fa fa-question-circle"></i>
      </va-popover>
      <p v-if="account.permission.updated_at">{{account.updated_at | readableDate | capitalize }}</p>
      <p v-else>---</p>
    </div>
  </va-card>
</template>

<script>
import CurrentLocaleMixin from '@/mixins/CurrentLocaleMixin'

export default {
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  mixins: [
    CurrentLocaleMixin
  ],
  filters: {
    capitalize: function (value) {
      return `${value.charAt(0).toUpperCase()}${value.slice(1)}`
    }
  }
}
</script>
